import {
  Box,
  Flex,
  Text,
  Avatar,
  Stack,
  Progress,
  Icon,
} from "@chakra-ui/react";
// import { useNavigate, useParams } from "react-router-dom";
import {
  newBorder,
  primary,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
  backgroundLight,
} from "../../../../utils/colors";
import dayjs from "dayjs";
// import StatusBadgeNew from "../../../../../components/badges/StatusBadgeNew";
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
// import { TbCake } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { TbDiscount } from "react-icons/tb";
import useNumberFormatter from "../../../../hooks/useNumberFormatter";

const TreatmentPlanCardMobile = ({
  treatmentPlan,
  onRowClick,
  currencySymbol,
}) => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  // const { slug } = useParams();

  const { _id, treatmentPlanID, status } = treatmentPlan;

  const patientName = `${treatmentPlan.patient?.lastName} ${treatmentPlan.patient?.firstName}`;

  const patientBirthDate = treatmentPlan.patient?.birthDate
    ? dayjs(treatmentPlan.patient?.birthDate).format("YYYY")
    : null;

  const createdAt = treatmentPlan.createdAt
    ? dayjs(treatmentPlan.createdAt).format("YYYY-MM-DD")
    : null;

  const totalServices =
    treatmentPlan.servicesNotCompleted + treatmentPlan.servicesCompleted;

  const formatNumber = useNumberFormatter(); // Get the formatting function
  const formattedPrice = formatNumber(treatmentPlan.totalPrice); // Call the function with totalPrice

  const patientBirthYear = patientBirthDate
    ? dayjs(patientBirthDate).format("YYYY")
    : "-";

  return (
    <Box
      borderRadius="1rem"
      bg={white}
      onClick={() => onRowClick(_id)}
      w="100%"
      border={`1px solid ${newBorder}`}
      p="1rem 0rem 1.5rem"
    >
      <Flex
        w="100%"
        align="center"
        justify="space-between"
        mt="0rem"
        p="0 1.5rem"
      >
        <Text fontSize="sm" fontWeight="500" color={textSecondary}>
          {t("treatmentPlan.treatmentPlanShort")}{" "}
          <Text as="span" fontWeight="500" color={textSecondary} ml={0.5}>
            {treatmentPlanID}
          </Text>
        </Text>

        <Text fontSize="sm" fontWeight="500" color={textSecondary}>
          {dayjs(createdAt).format("YYYY-MM-DD")}{" "}
        </Text>
      </Flex>

      <Flex w="100%" p="0.5rem 0 0rem">
        <Flex
          w="100%"
          justify="space-between"
          align="center"
          p="0.5rem 1.5rem 0"
        >
          <Flex align="center" gap={2}>
            <Avatar
              name={patientName}
              // src={image}
              w="2.25rem"
              h="2.25rem"
              bg={textPrimary}
              color={white}
            />
            <Stack spacing={0} w="100%">
              <Text
                fontSize="1rem"
                fontWeight="500"
                isTruncated
                color={textPrimary}
              >
                {patientName}
              </Text>
              <Flex align="center">
                <Text fontSize="sm" fontWeight="500" color={textSecondary}>
                  {patientBirthYear}
                  {/* <Text as="span" fontWeight="300" fontSize="sm" mx={1}>
                    |
                  </Text>{" "} */}
                  {/* afssaf */}
                </Text>
              </Flex>
            </Stack>
          </Flex>
        </Flex>
      </Flex>

      <Box w="100%" p="1rem 1.5rem 0rem">
        <Progress
          className="attendeesTotal"
          w="100%"
          value={(treatmentPlan.servicesCompleted / totalServices) * 100}
          mt="0.25rem"
          color={primary}
          size="sm"
          height="3px"
          borderRadius="0.5rem"
        />
      </Box>

      <Flex
        w="100%"
        align="center"
        justify="space-between"
        mt="1.25rem"
        p="0 1.5rem"
      >
        <StatusButtonNew
          isUnclickable
          currentStatus={status}
          options="treatment"
          p={"0 1rem"}
          h="2rem"
        />

        <Flex
          w="100%"
          // borderTop={`1px solid ${newBorder}`}
          p="0rem 0 0"
          justify="flex-end"
        >
          <Flex gap="0.5rem" align="center" w="100%" justify="flex-end">
            <Flex align="center" justify="flex-end">
              <Flex align="center" justify="flex--end" direction="column">
                <Flex align="center" justify="flex-end">
                  <Stack
                    gap={0}
                    textAlign="left"
                    mr={0}
                    // bg={backgroundLight}
                    // borderRadius="1rem"
                    // p="0.25rem"
                  >
                    <Text fontSize="sm" color={textSecondary} fontWeight="500">
                      <Text as="span" color={textSecondary} fontWeight="500">
                        {treatmentPlan.servicesCompleted}
                      </Text>
                      /{totalServices}
                    </Text>
                    {/* <Progress
                      className="attendeesTotal"
                      w="40px"
                      value={
                        (treatmentPlan.servicesCompleted / totalServices) * 100
                      }
                      mt="0.25rem"
                      color={primary}
                      size="sm"
                      height="3px"
                      borderRadius="0.5rem"
                    /> */}
                  </Stack>

                  <Flex
                    align="center"
                    ml={4}
                    justify="flex-end"
                    bg={backgroundLight}
                    borderRadius="1rem"
                    p="0.4rem 0.75rem"
                  >
                    {treatmentPlan.hasDiscount && (
                      <Flex
                        align="center"
                        justify="center"
                        textAlign="center"
                        mr={0}
                      >
                        <Icon
                          as={TbDiscount}
                          color={primaryAlt}
                          fontSize="0.875rem"
                          mr="0.125rem"
                          position="relative"
                          top="-1px"
                        />
                      </Flex>
                    )}
                    <Text
                      fontSize="sm"
                      color={textPrimary}
                      fontWeight="500"
                      whiteSpace="nowrap"
                      textAlign="right"
                    >
                      {currencySymbol} {formattedPrice}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default TreatmentPlanCardMobile;
